import { render, staticRenderFns } from "./BloodTypeDelete.vue?vue&type=template&id=0c7f4ab2&scoped=true&"
import script from "./BloodTypeDelete.vue?vue&type=script&lang=js&"
export * from "./BloodTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f4ab2",
  null
  
)

export default component.exports